import { render, staticRenderFns } from "./FormWizardButtonSlot.vue?vue&type=template&id=510149b9"
import script from "./FormWizardButtonSlot.vue?vue&type=script&lang=js"
export * from "./FormWizardButtonSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports